import React, { memo } from 'react';
import styled from 'styled-components';

const OutboundContainer = styled.div`
  position: relative;
  @media(max-width: 768px) {
    margin-left: -16px;
    margin-right: -16px;
  }
`;

const IFrame = styled.iframe`
  border-radius: 12px;
  height: 450px;
  width: 100%;
  @media(max-width: 768px) {
    height: 240px;
    border-radius: 0;
  }
`;

const TripVideo = props => {
  const { url, name } = props;
  return (
    <OutboundContainer>
      <IFrame
        title={name}
        src={`https://www.youtube.com/embed/${url}`}
        frameBorder="0"
        allowFullScreen
      />
    </OutboundContainer>
  );
};

export default memo(TripVideo, (prevProps, nextProps) => {
  if (prevProps.url !== nextProps.url) return false;
  if (prevProps.name !== nextProps.name) return false;
  return true;
});
